import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import styles from "../Animations/animations.module.css";

const Animations = ({
  animationType = "fadeInUp",
  className = "",
  style = {},
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1, // Adjust as needed
    });

    // Copy `elementRef.current` to a variable
    const currentElement = elementRef.current;

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  const animationClass = isVisible ? styles[animationType] : "";

  return (
    <div
      ref={elementRef}
      className={`${animationClass} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

Animation.propTypes = {
  animationType: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  threshold: PropTypes.number,
};

export default Animations;
